// extracted by mini-css-extract-plugin
export default {"confirmationWindow":"ZyYB","confirmationContainer":"j4Wa","confirmationButtonsContainer":"pYh9"};